import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CoreLink } from '../library/link';

import './link.scss';

export default function Link({
	href, to, onClick, className, color, children, hideBorder, rel, target, productClick,
	inheritFont, type
}) {
	return (
		<CoreLink
			href={href}
			to={to}
			onClick={onClick}
			rel={rel}
			target={target}
			type={type}
			className={
				classNames(className, color, { 'hide-border': hideBorder, inheritFont })
			}
		>
			<span className={classNames("link-content", color)}>
				{children}
			</span>
		</CoreLink>
	);
}

Link.propTypes = {
	/** color of Link */
	color: PropTypes.oneOf(['white', 'yellow', 'gray']),
	/** hides link underline */
	hideBorder: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node,
	href: PropTypes.string,
	to: PropTypes.string,
	onClick: PropTypes.func,
	rel: PropTypes.string,
	/** Fires the Product Clicked event when paired with ecommerce tracking */
	productClick: PropTypes.bool,
	target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
	inheritFont: PropTypes.bool,
	type: PropTypes.oneOf(['button'])
};
